import * as _selectors from './selectors'
import { getSortedlistOfAvailablePlans } from './plans'
import { getAllInvoices } from './invoices'

export const selectors = {
  ..._selectors,
  getSortedlistOfAvailablePlans,
  getAllInvoices,
}
